<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <select-extended
                v-model="inputValue"
                :clearable="clearable"
                :filter="options.length >= 8"
                autofocus-filter
                :filter-placeholder="$T('type to search')"
                :float-label="label | capitalize"
                :options="options"
                :color="color"
                :disable="form.busy || disable"
                :select-all="selectAll"
                :multiple="multiple"
                :chips="chips"
                :before="before"
                :after="after"
                :autofocus="autofocus"
                @input="onInput"></select-extended>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import SelectExtended from "./SelectExtended";

    export default {
        name: 'VSelect',
        components: {SelectExtended},
        mixins,

        props: {
            options: {
                type: Array,
                required: true
            },
            selectAll: Boolean,
            multiple: Boolean,
            chips: Boolean
        },
        data() {
            return {
                inputValue: this.multiple && !(this.value instanceof Array) ?
                    (this.value ? [this.value] : []) :
                    this.value
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VSelect.vue